import React from 'react';
import { SVGProps } from './types';

const CheckedCheckbox = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.5 1.915a.625.625 0 00-.625.625v15c0 .345.28.625.625.625h15c.345 0 .625-.28.625-.625v-15a.625.625 0 00-.625-.625h-15zm10.206 4.741l-3.995 4.359-1.468-1.468-1.179 1.178 2.7 2.699 5.17-5.642-1.228-1.126z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export { CheckedCheckbox };
